import { render, staticRenderFns } from "./addcount.vue?vue&type=template&id=3f53850c&scoped=true"
import script from "./addcount.vue?vue&type=script&lang=js"
export * from "./addcount.vue?vue&type=script&lang=js"
import style0 from "./addcount.vue?vue&type=style&index=0&id=3f53850c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f53850c",
  null
  
)

export default component.exports